import React from 'react';
import { connect } from 'react-redux';
import i18n from 'i18next';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// components
import SiteBar from 'src/components/siteBar/siteBar';
import CommunityHeader from 'src/modules/community/shared/components/header/communityHeader';
import Footer from 'src/components/footer';
import Animate from 'src/components/animate';
import Loader from 'src/components/loader';
import AdvertModal from 'src/modules/shared/modal/components/advertModal';
import CookieInfoBanner from 'src/components/cookieInfoBanner';
import FloatingSignupBox from 'src/components/floatingSignupBox';
import Alert from 'src/modules/shared/alert/components/alert';
import VerificationBar from 'src/components/verificationBar';

// actions
import { updateLanguage } from 'src/modules/shared/context/actions';
import { unsetAlert } from 'src/modules/shared/alert/actions';

// utils
import { isVisible as cookieInfoIsVisible } from 'src/utils/cookieBanner';
import head from 'src/utils/head';
const isServer = typeof window === 'undefined';

// styles
import stylesheet from 'styles/layouts/community.scss';

class CommunityLayout extends React.Component {
  static propTypes = {
    alert: PropTypes.object,
    community: PropTypes.object,
    currentUser: PropTypes.object,
    isLoading: PropTypes.bool,
    isLoggedIn: PropTypes.bool,
    lang: PropTypes.node,
    modal: PropTypes.object,
    newbies: PropTypes.array,
    seo: PropTypes.object,
    sideBarContent: PropTypes.object,
    unreadCount: PropTypes.node,
    updateLanguage: PropTypes.func,
  };

  static defaultProps = {
    alert: null,
    community: null,
    currentUser: null,
    isLoading: false,
    isLoggedIn: false,
    lang: null,
    modal: null,
    newbies: [],
    seo: null,
    sideBarContent: null,
    unreadCount: null,
    updateLanguage: () => {},
  };

  constructor(props) {
    super(props);
    this.state = {
      showScroll: false,
      showFloatingSignupBox: false,
    };
  }

  componentDidMount() {
    window.addEventListener('scroll', this.onScroll);
    if (screen.width <= 768) {
      window.addEventListener('scroll', this.onScrollMobile);
      return;
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('scroll', this.onScrollMobile);
  }

  onScrollMobile = () => {
    if (!this.state.showFloatingSignupBox && window.scrollY > 100) {
      this.setState({ showFloatingSignupBox: true });
    }
  }

  onScroll = () => {
    const { showScroll } = this.state;
    if (window.pageYOffset > 0) {
      if (!showScroll) {
        this.setState({
          showScroll: true,
          showFloatingSignupBox: true,
        });
      }
    } else if (showScroll) {
      this.setState({showScroll: false});
    }
  }

  scrollToTop = () => {
    document.body.scrollTop = 0;
    if (window.scrollTo) window.scrollTo(0, 0);
  }

  renderContent() {
    const { community, children, sideBarContent, showVerificationBar, newbies, isWriteCTAvisible, isSmallCommunity,
      currentUser, followCommunity, currentPage, headerTrackingSection } = this.props;
    const topClasses = classNames({
      'content-top-margin': !showVerificationBar,
      'content-top-margin--with-verification' : showVerificationBar,
    });

    return (
      <div className={topClasses}>
        <CommunityHeader
          community={community}
          currentPage={currentPage}
          currentUser={currentUser}
          isSmallCommunity={isSmallCommunity}
          isWriteCTAvisible={isWriteCTAvisible}
          newbies={newbies}
          trackingSection={headerTrackingSection}
          onFollow={followCommunity}
        />
        <div className="results community page-container">
          <div className="results__content">
            {children}
          </div>
          <div className="results__sidebar">
            {sideBarContent}
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { alert, community, currentUser, modal, seo, isLoggedIn, unsetAlert,
      unreadCount, updateLanguage, lang, showVerificationBar } = this.props;

    return <div>
      {community && head({
        ...seo,
        unreadCount,
      })}
      <style dangerouslySetInnerHTML={{ __html: stylesheet }} />
      <SiteBar
        community={community}
        lang={lang}
        pageType="community"
      />
      {currentUser && showVerificationBar && <VerificationBar />}
      {alert && (
        <Alert
          global={alert.global}
          type={alert.type}
          onFinished={unsetAlert}
        >
          {alert.message}
        </Alert>
      )}
      {!isServer && cookieInfoIsVisible() && <CookieInfoBanner />}
      {community ? this.renderContent() : <Loader />}
      {modal}
      <Animate transitionName="TRANSITION-simpleFade" show={this.state.showScroll}>
        <button
          type="button"
          className={'back-to-top back-to-top--navbar icon-up-open-1'}
          onClick={this.scrollToTop}
          title={i18n.t('Back to top')}
        />
      </Animate>
      <Footer
        isLoggedIn={isLoggedIn}
        lang={lang}
        updateLanguage={updateLanguage}
      />
      <AdvertModal name='advert__modal__1' />
      <AdvertModal name='advert__modal__2' />
      <Animate transitionName="TRANSITION-simpleFade" show={this.state.showFloatingSignupBox}>
        {!isLoggedIn && <FloatingSignupBox communitySlug={community.slug} />}
      </Animate>
    </div>;
  }
}

const mapStateToProps = (state) => {
  return {
    alert: state.alert.alert,
    modal: state.modal.modal,
    isLoggedIn: !!state.context.currentUser,
    currentUser: state.context.currentUser,
    showVerificationBar: state.context.showVerificationBar,
  };
};

export default connect(mapStateToProps, { updateLanguage, unsetAlert })(CommunityLayout);



// WEBPACK FOOTER //
// ./src/layouts/community.js